import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { FraudModeActionsProps } from './props';
import { useFraudModeListActions } from './hook';

export const FraudModeListActions = ({ id }: FraudModeActionsProps) => {
    const { handleEdit } = useFraudModeListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
